export default __webpack_public_path__ + "static/lozenge-dropdown-do-1-light-6116c5bd2131f33ab506132d73396d76.png";